import { useAuth } from 'context/authentication/useAuth'
import { AppLayout } from 'pages/app/layout'
import { AuthLayout } from 'pages/auth/layout'

export function CommonLayout() {
  const { isAuthenticated } = useAuth()
  if (isAuthenticated) return AppLayout()
  return AuthLayout()
}
